import type { DocActiveEmphasisKey } from '@listening/frontend/stores/audio-preferences-store';

/** Active-word styling for the docs text view, expressed as static
 * `data-[active=true]:` class literals (Tailwind-safe) so the highlight manager
 * can drive it purely by toggling `data-active` — no per-word React render.
 * One literal string per `docActiveEmphasis` mode. */
export function getDocsActiveWordClassName(
  docActiveEmphasis: DocActiveEmphasisKey,
) {
  if (docActiveEmphasis === 'highlight') {
    return 'data-[active=true]:rounded-[0.2rem] data-[active=true]:bg-[#DCE8FF] data-[active=true]:text-[#2443B8] dark:data-[active=true]:bg-[#2B447A]/60 dark:data-[active=true]:text-[#D9E4FF]';
  }
  if (docActiveEmphasis === 'underline') {
    return 'data-[active=true]:underline data-[active=true]:decoration-2 data-[active=true]:underline-offset-[0.24em] data-[active=true]:decoration-[#3f5ecf] dark:data-[active=true]:decoration-[#8fb0ff]';
  }
  return 'data-[active=true]:text-[#1E7FBF] dark:data-[active=true]:text-[#5daae3]';
}
